export const calculateHeight = (rowCount: number, customRowHeight?: number): number => {

  const rowHeight = customRowHeight ?? 45;
  const extraHeight = 30;

  return rowHeight*rowCount+extraHeight;
};
